// Tenant configuration based on domain
const getTenantConfig = () => {
  const hostname = window.location.hostname;
  
  if (hostname.includes('ytgator')) {
    return {
      name: 'YTGator',
      logo: '/ytgator-logo.png',
      primaryColor: '#FF6B00', // Orange
      secondaryColor: '#333333',
      heroTitle: 'YTGator Creator Network',
      heroSubtitle: 'Empowering YouTube Creators',
      favicon: '/ytgator-favicon.ico'
    };
  }
  
  // Default config for choicemcn.com
  return {
    name: 'Choice Network',
    logo: '/choice-logo.png', 
    primaryColor: '#6366F1', // Indigo
    secondaryColor: '#4F46E5',
    heroTitle: 'Choice MCN Platform',
    heroSubtitle: 'Multi-Channel Network for Content Creators',
    favicon: '/choice-favicon.ico'
  };
};

export default getTenantConfig;